// 存储
import type { ConstsConfig } from '../declare'

const consts: ConstsConfig[] = [
  // 接口请求统一 header
  {
    name: 'CACHE_HEADERS',
    value: 'cache_headers'
  },
  // 服务端指定 baseUrl
  {
    name: 'COOKIE_BASEURL',
    value: 'cookie_baseurl'
  },
  // 服务端指定 socket baseUrl
  {
    name: 'COOKIE_SOCKETURL',
    value: 'cookie_socketurl'
  },
  // 仅用于登录页组织的默认选中，其他环境切勿使用该 ORG_ID
  {
    name: 'COOKIE_ORG_ID',
    value: 'cookie_orgid'
  },
  // 帐套下的用户信息缓存: 账号密码 UserId
  {
    name: 'CACHE_LOGIN_INFO',
    value: 'cache_login_info'
  }
]

export default consts